import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import WarrantyForHouseWrapper from "@components/layouts/warrantyForHouseWrapper";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <WarrantyForHouseWrapper>
            <div className="bg-white">
                <ContactTop iconsFillColor="#6f91b8" />
            </div>
            <FormSection iconsFillColor="#efb03f" />
        </WarrantyForHouseWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
